import { BaseService } from "./BaseService";

export const UnidadeOrcamentariaService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-orcamentaria/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidade orcamentarias:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-orcamentaria', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de unidade orcamentarias:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('unidade-orcamentaria/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidade orcamentaria:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`unidade-orcamentaria/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de unidade orcamentarias:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`unidade-orcamentaria/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de unidade orcamentarias:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-orcamentaria/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir unidade orcamentarias:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-orcamentaria/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar unidade orcamentarias:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-orcamentaria/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar unidade orcamentarias:', error);
            return false;
        }
    }, 
}